import {useCustomQuery} from '@salesforce/commerce-sdk-react'
import useMultiSite from '@salesforce/retail-react-app/app/hooks/use-multi-site'

export const useDSSOrderDetail = (orderNo, options = {}) => {
    const {
        site: {id: siteId}
    } = useMultiSite()

    return useCustomQuery(
        {
            options: {
                method: 'POST',
                parameters: {
                    siteId
                },
                customApiPathParameters: {
                    apiName: 'dss-order-details',
                    apiVersion: 'v1',
                    endpointPath: '/dss-order-details'
                },
                body: JSON.stringify({
                    orderNo,
                    siteId
                })
            }
        },
        {
            keepPreviousData: false,
            cacheTime: 0,
            staleTime: 0,
            ...options
        }
    )
}
